import { Component, inject, ViewChild } from '@angular/core';
import { CodeableConceptField, CodeableConceptFieldFromBackEnd, FormFields, generalFieldsData, IndividualField, SingleCodeField } from '../../shared/dynamic-forms.interface2';
import { forkJoin } from 'rxjs';
import { FormFieldsSelectDataService } from '../../shared/form-fields-select-data.service';
import { DynamicFormsV2Component } from "../../shared/dynamic-forms-v2/dynamic-forms-v2.component";
import { formMetaData } from '../../shared/dynamic-forms.interface';
import { MatButtonModule } from '@angular/material/button';
import { FhirConversionService } from '../../shared/fhir-conversion.service';
import { UtilityService } from '../../shared/utility.service';
import { backendEndPointToken, backendEndPointValue } from '../../app.config';
import { StateService } from '../../shared/state.service';
import { HttpClient } from '@angular/common/http';
import { FhirResource } from 'fhir/r4';
import { ErrorService } from '../../shared/error.service';

@Component({
  selector: 'app-add-allergy',
  imports: [DynamicFormsV2Component, MatButtonModule],
  templateUrl: './add-allergy.component.html',
  styleUrl: './add-allergy.component.scss'
})
export class AddAllergyComponent {
  @ViewChild(DynamicFormsV2Component) dynamicForm!: DynamicFormsV2Component;

  allergyFields?: Map<string, { formFields: FormFields[];[key: string]: any }>;
  allformFields?: FormFields[];

  formFieldService = inject(FormFieldsSelectDataService);
  fhirService = inject(FhirConversionService);
  utilityService = inject(UtilityService);

  formMetaData: formMetaData = {
    formName: 'Add Allergy / Intolerance',
    formDescription: 'Record a clinical assessment of an allergy or intolerance.',
    submitText: 'Submit Allergy',
    showSubmitButton: false,
  };

  ngOnInit() {
    forkJoin({
      clinicalStatus: this.formFieldService.getFormFieldSelectData('allergy', 'clinicalStatus'),
      verificationStatus: this.formFieldService.getFormFieldSelectData('allergy', 'verificationStatus'),
      // type: this.formFieldService.getFormFieldSelectData('allergy', 'type'),
      // category: this.formFieldService.getFormFieldSelectData('allergy', 'category'),
      exposureRoute: this.formFieldService.getFormFieldSelectData('allergy', 'exposureRoute'),
      code: this.formFieldService.getFormFieldSelectData('allergy', 'code'),
      manifestation: this.formFieldService.getFormFieldSelectData('allergy', 'manifestation'),
      // criticality: this.formFieldService.getFormFieldSelectData('allergy', 'criticality'),
    }).subscribe((g: any) => {
      this.allergyFields = new Map<string, { formFields: FormFields[];[key: string]: any }>([
        // ['allergyName', {
        //   'formFields': <FormFields[]>[
        //     <IndividualField>{
        //       generalProperties: <generalFieldsData>{
        //         fieldApiName: 'allergyName',
        //         fieldName: "Allergic Substance / Code",
        //         fieldPlaceholder: "e.g. Latex Allergy or Penicillin",
        //         fieldType: 'IndividualField',
        //         inputType: 'text',
        //         isArray: false,
        //         isGroup: false,
        //         auth: { read: 'all', write: 'doctor, nurse' },
        //       },
        //     },
        //   ]
        // }],
        ['code', {
          'formFields': <FormFields[]>[
            <CodeableConceptFieldFromBackEnd>{
              generalProperties: <generalFieldsData>{
                fieldApiName: 'code',
                fieldName: "Allergic Substance / Code",
                fieldPlaceholder: "e.g. Latex Allergy or Penicillin",
                validations: [{
                  type: 'default',
                  name: 'required'
                }],
                fieldType: 'CodeableConceptFieldFromBackEnd',
                inputType: 'text',
                isArray: false,
                isGroup: false,
                allowedOthers: true,
                allowTextForCodeableConcept: true,
                auth: { read: 'all', write: 'doctor, nurse' },
              },
              data: ["https://tx.fhir.org/r4/ValueSet/$expand?url=http://hl7.org/fhir/ValueSet/allergyintolerance-code&_format=json"]
            },
          ]
        }],
        ['clinicalStatus', {
          'formFields': <FormFields[]>[
            <CodeableConceptField>{
              generalProperties: <generalFieldsData>{
                fieldApiName: 'clinicalStatus',
                fieldName: "Current Status",
                fieldType: 'CodeableConceptField',
                fieldPlaceholder: "Active",

                validations: [{
                  type: 'default',
                  name: 'required'
                }],
                inputType: 'text',
                isArray: false,
                isGroup: false,
                auth: { read: 'all', write: 'doctor, nurse' },
              },
              data: g.clinicalStatus
            },
          ]
        }],
        ['verificationStatus', {
          'formFields': <FormFields[]>[
            <CodeableConceptField>{
              generalProperties: <generalFieldsData>{
                fieldApiName: 'verificationStatus',
                fieldName: "Verification Status",
                fieldType: 'CodeableConceptField',
                fieldPlaceholder: "Confirmed",
                inputType: 'text',
                isArray: false,
                isGroup: false,
                validations: [{
                  type: 'default',
                  name: 'required'
                }],
                auth: { read: 'all', write: 'doctor, nurse' },
              },
              data: g.verificationStatus
            },
          ]
        }],
        ['type', {
          'formFields': <FormFields[]>[
            <CodeableConceptField>{
              generalProperties: <generalFieldsData>{
                fieldApiName: 'type',
                fieldName: "Type",
                fieldType: 'SingleCodeField',
                inputType: 'text',
                isArray: false,
                isGroup: false,
                fieldPlaceholder: "Allergy",

                auth: { read: 'all', write: 'doctor, nurse' },
              },
              data: "allergy | intolerance ".split("|").map((s: string) => s.trim())
            },
          ]
        }],
        ['category', {
          'formFields': [
            <CodeableConceptField>{
              generalProperties: <generalFieldsData>{
                fieldApiName: 'category',
                fieldName: "Category",
                fieldType: 'SingleCodeField',
                inputType: 'text',
                isArray: false,
                isGroup: false,

                auth: { read: 'all', write: 'doctor, nurse' },
              },
              data: "food | medication | environment | biologic".split("|").map((s: string) => s.trim())
            },
          ]
        }],
        ['criticality', {
          'formFields': <FormFields[]>[
            <CodeableConceptField>{
              generalProperties: <generalFieldsData>{
                fieldApiName: 'criticality',
                fieldName: "Criticality",
                fieldType: 'SingleCodeField',
                inputType: 'text',
                isArray: false,
                isGroup: false,
                auth: { read: 'all', write: 'doctor, nurse' },
              },
              data: "low | high | unable-to-assess".split("|").map((s: string) => s.trim())
            },
          ]
        }],
        ['onsetString', {
          'formFields': <FormFields[]>[
            <IndividualField>{
              generalProperties: <generalFieldsData>{
                fieldApiName: 'onsetString',
                fieldName: "When Did It Start?",
                fieldPlaceholder: "e.g. 2023-01-01 or Since childhood",
                fieldType: 'IndividualField',
                inputType: 'datetime-local',
                isArray: false,
                isGroup: false,
                auth: { read: 'all', write: 'doctor, nurse' },
              },
            },
          ]
        }],
        ['lastOccurrence', {
          'formFields': <FormFields[]>[
            <IndividualField>{
              generalProperties: <generalFieldsData>{
                fieldApiName: 'lastOccurrence',
                fieldName: "Last Occurrence",
                fieldPlaceholder: "Select date and time",
                fieldType: 'IndividualField',
                inputType: 'datetime-local',
                isArray: false,
                isGroup: false,
                auth: { read: 'all', write: 'doctor, nurse' },
              },
            },
          ]
        }],
        ['note', {
          'formFields': <FormFields[]>[
            <IndividualField>{
              generalProperties: <generalFieldsData>{
                fieldApiName: 'note',
                fieldName: "Additional Notes",
                fieldPlaceholder: "e.g. Patient has a history of latex allergy",
                fieldType: 'IndividualField',
                inputType: 'textarea',
                isArray: false,
                isGroup: false,
                auth: { read: 'all', write: 'doctor, nurse' },
              },
            },
          ]
        }],
      ]);

      this.allformFields = this.utilityService.convertFormFields(this.allergyFields!);
    });
  }

  submitAllergy() {
    if (this.dynamicForm) {
      const formData = this.dynamicForm.aForm.value;
      const fhirResource = this.fhirService.allergyFormToFhir(formData);
      console.log('Generated FHIR Resource:', fhirResource);
      // Here you would typically call a service to save the resource via HTTP POST
// $#$      // /* alert('Allergy resource generated. Check console for details.'); */
      // const patientId = formData.patientId || formData.subject?.reference?.split('/')[1];
      // Set Accept header to request full representation
      const headers = { headers: { 'Accept': 'application/fhir+json; fhirVersion=4.0', 'Prefer': 'return=representation' } };

      // Get backendUrl from app config (not hard-coded)
      // const backendUrl = this.backendUrl;
      // Persist locally via StateService
      // this.utilityService.stateService.persistPatientResource(fhirResource, 'unsaved');
      // if (!patientId) {
      //   console.error('Missing patient ID. Cannot persist allergy.');
      //   return;
      // }
      // const backendUrl = this.utilityService.getBackendUrl(); // Assumes utilityService exposes backend URL
      this.http.post<FhirResource>(`${this.backendUrl}/AllergyIntolerance`, fhirResource).subscribe({
        next: (response: FhirResource) => {
          console.log('AllergyIntolerance persisted:', response);
          // Optionally update patient resources in StateService/orgWideResources
          this.stateService.persistPatientResource(response, 'saved');
          // this.utilityService.notificationService.show('Allergy saved successfully.');
        },
        error: (err) => {
          this.errorService.openandCloseError('Failed to save allergy.');
          console.error('Error persisting allergy:', err);
        }
      });
    }
  }
  backendUrl = inject(backendEndPointToken);
  stateService = inject(StateService);
  http = inject(HttpClient);
  errorService = inject(ErrorService);

}
